module.exports = "iframe {\n  height: 1000px;\n  width: 100%; }\n"